export const DEFAULT_CACHE_MAX_AGE_IN_SECONDS = 600;
export const SEARCH_CACHE_MAX_AGE_IN_SECONDS = 600;
